import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { stat } from "fs"
import HelpDocument from "models/help-document"

export interface HelpDocumentSliceState {
  helpDocuments: Record<string, HelpDocument>
}

export const initialState: HelpDocumentSliceState = {
  helpDocuments: {},
}

const helpDocumentSlice = createSlice({
  name: "helpDocument",
  initialState,
  reducers: {
    setHelpDocuments(state, { payload }: PayloadAction<HelpDocument[]>) {
      for (let i = 0; i < payload.length; i++) {
        state.helpDocuments[payload[i].code] = payload[i]
      }
    },
  },
})

export const { setHelpDocuments } = helpDocumentSlice.actions

export default helpDocumentSlice.reducer